import createStore from 'unistore'

export interface RootState {}

const store = createStore({})

export default store
